import { render, staticRenderFns } from "./JobTypes.vue?vue&type=template&id=aff4bcce&"
import script from "./JobTypes.vue?vue&type=script&lang=js&"
export * from "./JobTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports